import type { ParseKeys } from 'i18next';
import type { LucideIcon } from 'lucide-react';
import {
  ClipboardPlus,
  FileCheck,
  FileHeart,
  FileImage,
  FileLineChart,
  FileText,
  HeartPulse,
  Pill,
  Slice,
} from 'lucide-react';
import { z } from 'zod';
import { PATIENT_360_ROUTES } from '@/features/patient-360/consts/routes';

const { index: _, ...menuRoutes } = PATIENT_360_ROUTES;

export type MenuKey = keyof typeof menuRoutes;
export const menuKeySchema = z.enum(Object.keys(menuRoutes) as MenuKey[]);

type MenuItemDef = {
  icon: LucideIcon;
  i18nKey: ParseKeys<['glossary']>;
  route: string;
};

export const MENU_ITEMS_MAP = {
  visits: {
    icon: ClipboardPlus,
    // t('glossary:functionMenu.patient360.visits')
    i18nKey: 'glossary:functionMenu.patient360.visits',
    route: PATIENT_360_ROUTES.visits,
  },
  labReports: {
    icon: FileLineChart,
    // t('glossary:functionMenu.patient360.labReports')
    i18nKey: 'glossary:functionMenu.patient360.labReports',
    route: PATIENT_360_ROUTES.labReports,
  },
  imagingReports: {
    icon: FileImage,
    // t('glossary:functionMenu.patient360.imagingReports')
    i18nKey: 'glossary:functionMenu.patient360.imagingReports',
    route: PATIENT_360_ROUTES.imagingReports,
  },
  examReports: {
    icon: FileCheck,
    // t('glossary:functionMenu.patient360.examReports')
    i18nKey: 'glossary:functionMenu.patient360.examReports',
    route: PATIENT_360_ROUTES.examReports,
  },
  pathologyReports: {
    icon: FileHeart,
    // t('glossary:functionMenu.patient360.pathologyReports')
    i18nKey: 'glossary:functionMenu.patient360.pathologyReports',
    route: PATIENT_360_ROUTES.pathologyReports,
  },
  surgeryReports: {
    icon: Slice,
    // t('glossary:functionMenu.patient360.surgeryReports')
    i18nKey: 'glossary:functionMenu.patient360.surgeryReports',
    route: PATIENT_360_ROUTES.surgeryReports,
  },
  vitalSigns: {
    icon: HeartPulse,
    // t('glossary:functionMenu.patient360.vitalSigns')
    i18nKey: 'glossary:functionMenu.patient360.vitalSigns',
    route: PATIENT_360_ROUTES.vitalSigns,
  },
  diagnosisCertificates: {
    icon: FileText,
    // t('glossary:functionMenu.patient360.diagnosisCertificates')
    i18nKey: 'glossary:functionMenu.patient360.diagnosisCertificates',
    route: PATIENT_360_ROUTES.diagnosisCertificates,
  },
  medications: {
    icon: Pill,
    // t('glossary:functionMenu.patient360.medications')
    i18nKey: 'glossary:functionMenu.patient360.medications',
    route: PATIENT_360_ROUTES.medications,
  },
  chronicDisease: {
    icon: HeartPulse,
    // t('glossary:functionMenu.patient360.chronicDisease')
    i18nKey: 'glossary:functionMenu.patient360.chronicDisease',
    route: PATIENT_360_ROUTES.chronicDisease,
  },
  vaccinations: {
    icon: HeartPulse,
    // t('glossary:functionMenu.patient360.vaccinations')
    i18nKey: 'glossary:functionMenu.patient360.vaccinations',
    route: PATIENT_360_ROUTES.vaccinations,
  },
  cloudPharmacy: {
    icon: HeartPulse,
    // t('glossary:functionMenu.patient360.cloudPharmacy')
    i18nKey: 'glossary:functionMenu.patient360.cloudPharmacy',
    route: PATIENT_360_ROUTES.cloudPharmacy,
  },
} as const satisfies Partial<Record<MenuKey, MenuItemDef>>;
